import { useEffect, useRef } from 'react';

const DEFAULT_EVENTS: (keyof DocumentEventMap)[] = ['keypress', 'click', 'scroll'];

// This hook tracks the last user activity timestamp from DEFAULT_EVENTS and treat user as active or not
export const useLastUserActivityRef = () => {
	const lastActivityRef = useRef<number>(0);

	useEffect(() => {
		const handleEvents = () => {
			lastActivityRef.current = Date.now();
		};

		DEFAULT_EVENTS.forEach((event) => document.addEventListener(event, handleEvents));

		return () => {
			DEFAULT_EVENTS.forEach((event) =>
				document.removeEventListener(event, handleEvents),
			);
		};
	}, []);

	return lastActivityRef;
};
